module.exports = __webpack_public_path__ + "static/media/email_icon.d5510066.svg";